import { config } from '@/config';

interface YotiIFrameProps {
    sessionId: string;
    sessionToken: string;
    height?: number;
}

export const YotiIFrame = ({ sessionId, sessionToken, height }: YotiIFrameProps) => {
    return (
        <iframe
            id="yoti_iframe"
            name="yoti_iframe"
            allow="camera"
            style={{ height: height ?? '600px', width: '100%', border: 'none' }}
            src={`${config.api.url.yotiSrc}/idverify/v1/web/index.html?sessionID=${sessionId}&sessionToken=${sessionToken}`}
            data-testid="yotiIframe"
        />
    );
};
